<template>
  <div>
    <div style="margin-bottom: 15px;background:#ccc; width:100%;position: relative;">
      <div style="float:left;width:20%;">
        <img src="../../../assets/show/index_m0.jpg" />
      </div>
      <div style="width:80%;position: absolute;right:0px;">
        <a-dropdown>
          <a-button icon="read" @mouseenter="NewsCenterEnter" >新闻中心</a-button>
        </a-dropdown>
        <a-dropdown>
          <a-button icon="read" @mouseenter="PoliciesRegulationsEnter">政策法规</a-button>
        </a-dropdown>
        <a-dropdown>
          <a-button icon="read" @mouseenter="LandTrusteeshipEnter">土地托管</a-button>
        </a-dropdown>
        <a-dropdown>
          <a-button icon="read" @mouseenter="LandTransferEnter">土地流转</a-button>
        </a-dropdown>
        <a-dropdown>
          <a-button icon="read" @mouseenter="NoticeEnter">通告通知</a-button>
        </a-dropdown>
      </div>
      <div v-show="topitem" style="background:#fff;padding-top:80px; width:80%;float:right" >
        <a-list bordered :data-source="listData">
          <a-list-item v-for="(item, index) of listData" :key="index" :value="item.title">
            <a @click="TextcontentClick(item.id)" style="color:#000">
              <span style="float:left">{{ item.title }}</span>
            </a>
            <a @click="TextcontentClick(item.id)" style="color:#000">
              <span style="float:right">{{ item.publishTime }} </span>
            </a>
          </a-list-item>
        </a-list>
      </div>
      <div v-show="LandTrustitem" style="background:#fff;padding-top:80px; width:80%;float:right">
        <citysearch-Box title="土地全托" tType="0" style="float:left;background:#ccc;width:49%"></citysearch-Box>
        <citysearch-Box title="土地半托" tType="1" style="float:right;background:#ccc;width:49%"></citysearch-Box>
        <div style="clear: both"></div>
      </div>
      <!-- 土地流转 -->
      <div v-show="Machineryitem" style="background:#fff;padding-top:80px; width:80%;float:right">
        <a-table :columns="Machinerycolumns" :data-source="listData.slice(0, 5)" :pagination="pagination" >
        </a-table>
        <div style="clear: both"></div>
      </div>
      <div style="position:absolute;right:10px;bottom:5px;" @click="MoreClick"><span style="font-weight:600;">更多》</span></div>
      <div style="clear:both"></div>
    </div>
  </div>
</template>
<script>
import { InfoMainWebPage } from '@/api/main/InfoMainManage'
import { LandTransferAreaWebPage } from '@/api/main/LandTransferAreaManager'
import citysearchBox from '@/layouts/topBox/cityBox/citysearchBox.vue'
export default {
  components: {
    citysearchBox
  },
  data() {
    return {
      topitem: true,
      LandTrustitem: false,
      Machineryitem: false,
      listData: [],
      InfoData: [],
      NoticeData: [],
      PoliciesRegulationsData: [],
      infoType: 1,
      pagination: {
        pageSize: 4
      },
      Machinerycolumns: [
        {
          title: '片区名',
          dataIndex: 'areaName'
        },
        {
          title: '片区面积',
          dataIndex: 'areaSize',
          width: 140
        },
        {
          title: '租赁价格',
          dataIndex: 'price',
          width: 140
        },
        {
          title: '发布日期',
          dataIndex: 'publishDate',
          width: 240
        }
      ]
    }
  },
  created() {
    this.NewsCenterEnter()
  },
  methods: {
    loadData() {
      if (this.infoType === 101) {
        LandTransferAreaWebPage({ orgId: this.orgId }).then(res => {
        this.listData = ''
        this.listData = res.data.rows
      })
      } else {
        InfoMainWebPage({ orgId: this.orgId, infoType: this.infoType }).then(res => {
        this.listData = ''
        this.listData = res.data.rows
      })
      }
    },
    NewsCenterEnter() {
        this.infoType = 1
        this.topitem = true
        this.LandTrustitem = false
        this.Machineryitem = false
        this.loadData()
    },
    PoliciesRegulationsEnter() {
        this.infoType = 2
        this.topitem = true
        this.LandTrustitem = false
        this.Machineryitem = false
        this.loadData()
    },
    LandTrusteeshipEnter() {
        this.topitem = false
        this.LandTrustitem = true
        this.Machineryitem = false
    },
    LandTransferEnter() {
      this.infoType = 101
        this.topitem = false
        this.LandTrustitem = false
        this.Machineryitem = true
      this.loadData()
    },
    NoticeEnter() {
      this.infoType = 3
      this.topitem = true
      this.LandTrustitem = false
      this.Machineryitem = false
      this.loadData()
    },
    MoreClick() {
      const go = this.$router.resolve({ path: 'AgriculturalServices', query: { title: this.systitle, infoType: this.infoType } })
      window.open(go.href, '_blank')
    },
    TextcontentClick(id) {
      const go = this.$router.resolve({ path: 'Textcontent', query: { id } })
      window.open(go.href, '_blank')
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>
<style scoped>
.ant-btn {
  float: left;
  width: 170px;
  height: 75px;
  font-family: Arial;
  font-weight: 800;
  font-size: 16px;
  margin-left: 5px;
  background: #e6dfcf;
}
.ant-btn:focus {
  color: #fff;
  background: #207e63;
}
.ant-btn:first {
  margin-left: 200px;

}
</style>
